import Model from './Model'

export default class Mailsegment extends Model {
    resource() {
        return 'mailsegment'
    }

    get active_leads()
    {
        return this.activeleads
    }

}
